import { createContext, useContext, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { DICT, get } from "./dict";

const LocaleContext = createContext({ locale: "de", t: (k) => k, prefix: "" });

export function LocaleProvider({ children }) {
  const { pathname } = useLocation();
  const locale = pathname === "/en" || pathname.startsWith("/en/") ? "en" : "de";
  const prefix = locale === "en" ? "/en" : "";
  const value = useMemo(() => {
    const t = (path, fallback = "") => {
      const v = get(locale, path);
      return v === undefined || v === null ? (fallback || path) : v;
    };
    return { locale, t, prefix, dict: DICT[locale] };
  }, [locale, prefix]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export const useT = () => useContext(LocaleContext);

// Localized <Link> that automatically prefixes /en when active
export function LLink({ to, children, ...rest }) {
  const { prefix } = useT();
  const normalized = to.startsWith("/") ? `${prefix}${to === "/" ? "" : to}` : to;
  return <Link to={normalized || "/"} {...rest}>{children}</Link>;
}
